/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type BuyAgainPurchase } from '@/features/orderHistory';
import { ActionCandidates } from '@/components/ActionCandidates';
import { ActionCandidatesProvider } from '@/components/ActionCandidates/context/ActionCandidatesProvider';

type BuyAgainContainerProps = {
  purchases: BuyAgainPurchase[];
  limit: number;
  label: string;
  onClose: () => void;
};

export const BuyAgainContainer = ({ purchases, label, limit, onClose }: BuyAgainContainerProps) => {
  const displayedPurchases = purchases.slice(0, limit);
  const isProductCountOverLimit = !!limit && purchases.length > limit;
  const isOneProduct = displayedPurchases.length === 1;

  const handleClose = () => {
    onClose();
  };

  if (displayedPurchases.length === 0) {
    return null;
  }

  return (
    <ActionCandidatesProvider isOneProduct={isOneProduct} buyAgainCandidates={displayedPurchases}>
      <ActionCandidates
        label={label}
        handleClose={handleClose}
        isProductCountOverLimit={isProductCountOverLimit}
      />
    </ActionCandidatesProvider>
  );
};
